import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
const TOTAL_SECONDS = 35 * 60 + 52;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: Math.floor(remaining / 3600),
    suffix: 'ore'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'min'
  }, {
    value: remaining % 60,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-tangerine text-white" data-id="element-38" data-mp="28gfecdrvyc2f">
      
    </div>;
}